export const REQUEST_ERROR = "@errors/REQUEST_ERROR";
